import { render, staticRenderFns } from "./ConfirmView.vue?vue&type=template&id=997cdc7e"
import script from "./ConfirmView.vue?vue&type=script&lang=js"
export * from "./ConfirmView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports